import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';

@Component({
  selector: 'app-manage-service',
  templateUrl: './manage-service.component.html',
  styleUrls: ['./manage-service.component.scss']
})
export class ManageServiceComponent implements OnInit {

  ManageServiceTab: string = "nav-service-group";
  isViewService: boolean = false;
  isViewServiceGroup: boolean = true;
  isViewActivity: boolean = false;
  isViewServiceActivityMapping: boolean = false;
  isViewServiceTaxMapping:boolean=false;
  constructor(public global: GlobalComponent) {
    this.global.checkforlogout();
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == '' || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;

    }
  }

  ngOnInit(): void {
  }

  tabChanged(tab) {
    this.ManageServiceTab = tab;
    this.isViewService = false;
    this.isViewServiceGroup = false;
    this.isViewActivity = false;
    this.isViewServiceActivityMapping= false;
    if (this.ManageServiceTab == 'nav-service-group') {
      this.isViewServiceGroup = true;
    }
    else{
      this.isViewServiceGroup = false;
     
    }
     if (this.ManageServiceTab == 'nav-service') {
      this.isViewService = true;
    }
    else{
      this.isViewService = false;
      
    }
     if (this.ManageServiceTab == 'nav-service-activity') {
      this.isViewServiceActivityMapping= true;
    }
    else{
    
      this.isViewServiceActivityMapping= false;
     
    }
     if (this.ManageServiceTab == 'nav-activity') {
      this.isViewActivity = true;
    }
    else{
     
      this.isViewActivity = false;
    }
     if(this.ManageServiceTab == 'nav-service-tax-activity') {
      this.isViewServiceTaxMapping=true;
    }else{
      
      this.isViewServiceTaxMapping=false;
    }
  }

 
  items = ['Zero', 'One', 'Two', 'Three'];

  items2 = ['Zero', 'One', 'Two', 'Three'];
    // ..................................................................Drag and Drop..................................
    drop(event: CdkDragDrop<string[]>) {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex);
      }
    }

  checkpopServiceActivity() {
    this.isViewServiceActivityMapping = true;
  }
    
  valuchangesServiceActivity() {
    this.isViewServiceActivityMapping = false;
  }
  
}


